const allFeatures = [
    {
        id: 1,
        name: 'SALES MANAGEMENT MADE SUPER EASY',
        subMenu: [
            {
                name: 'Excel upload', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Facebook Auto Lead Capture', 
                description: 'Instantly engage and turn your Facebook leads into deals',
                image: 'calling_auto_dialer',
                points: [
                    "Automatically capture FB Leads in CRM in real-time",
                    "Engage through WhatsApp, SMS, email, and call",
                    "Capture complete lead interaction history in CRM"
                ]
            },
            {
                name: 'Excel upload', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Custom API Integration', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
        ]
    },
    {
        id: 2,
        name: 'BASICS: YOUR DAY-TO-DAY SALES ACTIVITIES ON STEROIDS',
        subMenu: [
            {
                name: 'WhatsApp Notifications', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Autodialer', 
                description: 'Instantly engage and turn your Facebook leads into deals',
                image: 'calling_auto_dialer',
                points: [
                    "Automatically capture FB Leads in CRM in real-time",
                    "Engage through WhatsApp, SMS, email, and call",
                    "Capture complete lead interaction history in CRM"
                ]
            },
            {
                name: 'Click-to-call from Web', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Call Recording', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
            {
                name: 'Follow-up Reminders', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
            {
                name: '1-Click WhatsApp', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
        ]
    },
    {
        id: 3,
        name: 'REPORTS THAT MATTER FOR YOUR BUSINESS',
        subMenu: [
            {
                name: 'Hour-by-hour Report', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Daily Reports', 
                description: 'Instantly engage and turn your Facebook leads into deals',
                image: 'calling_auto_dialer',
                points: [
                    "Automatically capture FB Leads in CRM in real-time",
                    "Engage through WhatsApp, SMS, email, and call",
                    "Capture complete lead interaction history in CRM"
                ]
            },
            {
                name: 'Leaderboard Report', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Sales Report', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
            {
                name: 'Sales Report', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
            {
                name: 'Agents Report', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
            {
                name: 'Custom Report', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
        ]
    },

    {
        id: 4,
        name: 'SALES MANAGEMENT MADE SUPER EASY',
        subMenu: [
            {
                name: 'Excel upload', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Facebook Auto Lead Capture', 
                description: 'Instantly engage and turn your Facebook leads into deals',
                image: 'calling_auto_dialer',
                points: [
                    "Automatically capture FB Leads in CRM in real-time",
                    "Engage through WhatsApp, SMS, email, and call",
                    "Capture complete lead interaction history in CRM"
                ]
            },
            {
                name: 'Excel upload', 
                description: 'Import your data and get started without any worries or hassle',
                image: 'calling_auto_dialer',
                points: [
                    "Upload any format you need.",
                    "Easily map with intuitive UI",
                    "No Limit on the number of rows"
                ]
            },
            {
                name: 'Custom API Integration', 
                description: 'To get the data you want in your CRM',
                image: 'calling_auto_dialer',
                points: [
                    "Capture leads from anywhere",
                    "Capture lead activity like website visits, etc",
                    "Update leads based on external eventss"
                ]
            },
        ]
    },
]


export default allFeatures;
